<template>
  <div class="kb-rag-empty">
    <div class="kb-rag-inner">
      <BaseIcon icon="md-git-network" :size="72" color="var(--subtext3)" />
      <h2>RAG 转换与 AI 管理</h2>
      <p>向量知识库同步、分块策略与检索配置将在此模块提供，敬请期待。</p>
      <Tag color="blue">开发中</Tag>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/Icon';

export default {
  components: {BaseIcon},
};
</script>

<style lang="less" scoped>
.kb-rag-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg2);
}

.kb-rag-inner {
  text-align: center;
  padding: 48px;
  max-width: 420px;

  h2 {
    margin: 20px 0 8px;
    font-size: 20px;
  }

  p {
    color: var(--subtext2);
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 16px;
  }
}
</style>
